'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.new-feis-invite', ['ngMaterial']).factory('fFeisInviteDialog', function ($mdDialog) {
  return function (ev) {
    return $mdDialog.show({
      controller: 'FeisInviteDialogController',
      template: require('./tpl.html'),
      targetEvent: ev
    });
  };
}).controller('FeisInviteDialogController', function ($scope, $mdDialog) {
  $scope.invite = {
    fee: 5.00,
    deposit: 1000.00
  };

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  $scope.create = function (invite) {
    $mdDialog.hide(angular.copy(invite));
  };
});


//////////////////
// WEBPACK FOOTER
// ./new-feis-invite/index.js
// module id = 487
// module chunks = 0